module.exports = __webpack_public_path__ + "static/fonts/NeueAugenblick-Bold.a2ec4436.woff2";